import {SyntheticEvent} from "react"
import {connect} from "react-redux"
import {toggleAccordionAction, setFilterClearTypeAction} from "../../ducks/search"
import State from "../../models/State"
import {isFilterFacet} from "../../models/Filter/typeGuards"
import TrackFilterClear from "../../events/trackEvent/events/trackFilterClear"

type OwnProps = {
    name: string
    displayName: string
}

export const mapStateToProps = (state: State, ownProps: OwnProps) => {
    const filter = state.search.filters[ownProps.name]
    const {facets} = state.search
    const {text} = state

    let isFilterSelected = false

    if (isFilterFacet(filter)) {
        isFilterSelected = filter.facets.some(facet => facets[facet] && facets[facet].s === true)
    }

    return {
        ...ownProps,
        displayName: filter.displayName,
        isOpen: filter.isFilterOpen,
        type: filter.type,
        isFilterSelected,
        text,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    toggleAccordionAction: ({
        event,
        name,
        displayName,
    }: {
        event: SyntheticEvent<Element, Event>
        name: string
        displayName: string
    }) => {
        dispatch(toggleAccordionAction({event, name, displayName}))
    },
    clearTypeFilters: ({name, displayName}: {name: string; displayName: string}) => {
        TrackFilterClear(displayName)
        dispatch(setFilterClearTypeAction(name))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
